var irreducible = require('./irreducible');
var isType = require('./isType');

module.exports = irreducible('Type', isType);


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb/lib/Type.js
// module id = 696
// module chunks = 0